import React, { useCallback } from 'react'
import { Modal } from 'antd'
import PropTypes from 'prop-types'

import { RejectDocumentMenuCrawlingForm } from '../../forms'

const onSubmit = (variables, onReject) => {
  const { crawlingRejectedComment } = variables
  return onReject(crawlingRejectedComment)
}

const RejectDocumentMenuCrawlingModal = ({
  taskId,
  menu,
  isModalOpen,
  setIsModalOpen,
  onReject,
  isRejectingTask,
}) => {
  const handleSubmit = useCallback(menu => onSubmit(menu, onReject), [onReject])

  return (
    <Modal
      title="Reject crawling"
      visible={isModalOpen}
      onCancel={() => setIsModalOpen(false)}
      footer={null}
    >
      <RejectDocumentMenuCrawlingForm
        taskId={taskId}
        crawlingRejectedComment={menu.crawlingRejectedComment}
        closeModal={() => setIsModalOpen(false)}
        isRejectingMenu={isRejectingTask}
        onSubmit={handleSubmit}
      />
    </Modal>
  )
}

RejectDocumentMenuCrawlingModal.propTypes = {
  taskId: PropTypes.string.isRequired,
  menu: PropTypes.object.isRequired,
  isModalOpen: PropTypes.bool.isRequired,
  setIsModalOpen: PropTypes.func.isRequired,
  onReject: PropTypes.func.isRequired,
  isRejectingTask: PropTypes.bool.isRequired,
}

export default RejectDocumentMenuCrawlingModal
